import { render } from "./ClockIcon.vue?vue&type=template&id=65215152"
const script = {}
script.render = render

export default script